export const realtorData = { email: '21becauseyes@gmail.com' };